import { render, staticRenderFns } from "./ApprovalSettings.vue?vue&type=template&id=10dde817"
import script from "@/views/modules/Administration/js/ApprovalSettings.js?vue&type=script&lang=js&external"
export * from "@/views/modules/Administration/js/ApprovalSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports